export const REWORK_AREA_CONTAINER_ID = 'reworkArea';
